import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const formSlice = createSlice({
  name: "form",
  initialState: {},
  reducers: {
    globalValue: (state, action) => {
      return { ...state, ...action.payload };
    },
    clearFormDataGlobal: () => initialState,
  },
});

export const { clearFormDataGlobal, globalValue } = formSlice.actions;

export default formSlice.reducer;
